/**
 * Navbar — barra superior do dashboard.
 *
 * Simplificada: logótipo à esquerda, três ícones à direita (tema,
 * notificações, perfil). A saudação "Olá, X 👋" saiu — repetia o que o
 * dashboard já diz em letra grande logo por baixo — e o botão "Sair"
 * mudou-se para dentro do menu do avatar (ver UserMenu).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/dozy-logo.svg';
import Icon from './Icon.js';
import ThemeToggle from './ThemeToggle.js';
import UserMenu from './UserMenu.js';

export const Navbar = () => {
  const { user } = useAuth();

  return (
    <header className="navbar">
      <Link to={user?.role === 'worker' ? '/worker' : '/dashboard'} className="navbar-brand">
        <img src={logo} alt="" className="navbar-logo" />
        <span className="navbar-title">DOZY</span>
      </Link>

      <div className="navbar-spacer" />

      <div className="navbar-user" style={{ gap: '4px' }}>
        <ThemeToggle />
        <Link
          to="/notifications"
          aria-label="Notificações"
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '44px', height: '44px', borderRadius: 'var(--radius-sm)',
            color: 'var(--text-secondary)', textDecoration: 'none',
          }}
        >
          <Icon name="bell" size={20} />
        </Link>
        <UserMenu />
      </div>
    </header>
  );
};
